import axios from 'axios';

async function CalculateDistances(waypoints) {
  try {
    const response = await axios.post('/api/calculate-distance', 
      waypoints
    );

    return response.data.distanceKm;
  } catch (error) {
    console.error('Fehler beim Abruf der Distanz:', error.message);
    return null;
  }
}

export default CalculateDistances;

